import { render, staticRenderFns } from "./send-notice-dialog.vue?vue&type=template&id=32e1da7e&scoped=true&"
import script from "./send-notice-dialog.vue?vue&type=script&lang=js&"
export * from "./send-notice-dialog.vue?vue&type=script&lang=js&"
import style0 from "./send-notice-dialog.vue?vue&type=style&index=0&id=32e1da7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1da7e",
  null
  
)

export default component.exports